export default {
    loading: 'report:loading',
    search: 'report:search',
    reportData: 'report:reportData',
    url: 'report:url',
}



// WEBPACK FOOTER //
// ./pages/StatisticalAnalysis/report/constant.js